import actionTypes from "../actions/actionTypes";
let _ = require("lodash");

const initialState = {
    accessToken: null,
    businessStream: false,
    userInfo: '',
    modalOpen: false,
    groupSessionResult: {
        content: []
    },
    noResultFoundGroupSession: false,
    isLoading: false,
    searchListPayload: [
        {
            "filterKey": "session",
            "operation": "eq",
            "value": ""
        },
        {
            "filterKey": "assessmentCode",
            "operation": "eq",
            "value": ""
        },
        {
            "filterKey": "componentId",
            "operation": "eq",
            "value": ""
        },
        {
            "filterKey": "timeZone",
            "operation": "eq",
            "value": ""
        },
        {
            "filterKey": "businessStream",
            "operation": "eq",
            "value": ""
        },
    ],
    sortData: "",
    allBusinessStreams: [],
    apiError: false,
    seriesList: [{
        id: ""
    }],
    assesmentList: [],
    componentList: [],
    resetData: false,
    isComponentReupdate: false,
    isAssesmentReupdates: false,
    timeZoneList: [],
    centerList: [],
    isLoadingSeriesList: false,
    cgsData: {
        name: ''
    },
    snackBarInfo: {
        open: false,
        info: ''
    },
    centerListApi: [],
    defaultValueSet: true,
    transferToCgs: {
        id: ''
    },
    totalCenters: 0,
    candidatesList: [],
    finalListOfCenter: [],
    finalListOfCandidates: [],
    totalCandidate: 0,
    selectedCenterId: [],
    searchLoading: false,
    replaceTestData: []
};

const dhsApplicationDataStore = (state = initialState, action) => {
    switch (action.type) { // NOSONAR
        case actionTypes.ACCESS_TOKEN:
            return {
                ...state,
                accessToken: action.payload.accessToken,
            };

        case actionTypes.GET_CGS_DETAILS:
            return {
                ...state,
                cgsData: action.payload,
            };

        case actionTypes.SELECTED_CENTER_ID:
            return {
                ...state,
                selectedCenterId: Array.from(action.payload),
                candidatesList: []
            };


        case actionTypes.SET_DEFAULT_VALUE: {
            const newState = JSON.parse(JSON.stringify(state));
            let idName = (action.payload.name === 'session') ? 'id' : action.payload.name;
            let idValue = _.get(action, `payload.value.${idName}`, '');

            const index = newState.searchListPayload.findIndex(obj => obj['filterKey'] === action.payload.name);

            if (action.payload.value) {
                newState.searchListPayload[`${index}`].value = idValue
            }
            return newState;
        };

        case actionTypes.INFO_SNACKBAR:
            return {
                ...state,
                snackBarInfo: {
                    open: action.payload.open,
                    info: action.payload.info,
                    isSuccess: action.payload.isSuccess
                },
            };

        case actionTypes.GET_REPLACE_TEST_DATA:
            return {
                ...state,
                replaceTestData: action.payload.data.content,
                replaceTestDataTotalCount: action.payload.data.totalElements,
            }

        case actionTypes.UPDATE_CLONE_DATA:
            return {
                ...state,
                cgsData: {
                    ...state.cgsData,
                    startDate: action.payload.startDate,
                    endDate: action.payload.endDate,
                    name: action.payload.name,
                    suffix: action.payload.suffixName
                }
            };

        case actionTypes.BUSINESS_STREAM:
            return {
                ...state,
                businessStream: action.payload,
                isLoading: false
            };

        case actionTypes.SORTING_DATA:
            return {
                ...state,
                sortData: action.payload,
            };

        case actionTypes.SEARCH_LOADING:
            return {
                ...state,
                searchLoading: action.payload,
            };


        case actionTypes.RESET_DATA:
            return {
                ...state,
                resetData: action.payload,
                noResultFoundGroupSession: false,
            };

        case actionTypes.RESET_SEARCH_RESULT_DROPDOWN:
            return {
                ...state,
                groupSessionResult: {
                    content: []
                },
                searchListPayload: [
                    {
                        "filterKey": "session",
                        "operation": "eq",
                        "value": ""
                    },
                    {
                        "filterKey": "assessmentCode",
                        "operation": "eq",
                        "value": ""
                    },
                    {
                        "filterKey": "componentId",
                        "operation": "eq",
                        "value": ""
                    },
                    {
                        "filterKey": "timeZone",
                        "operation": "eq",
                        "value": ""
                    },
                    {
                        "filterKey": "businessStream",
                        "operation": "eq",
                        "value": ""
                    },
                ],
                componentList: [],
                assesmentList: [],
                seriesList: [],
                centerList: [],
            }

        case actionTypes.GET_ALL_CENTER_LIST:
            return {
                ...state,
                centerListApi: action.payload,
            }

        case actionTypes.TRANSFER_TO_GROUP_SESSION_DATA:
            return {
                ...state,
                transferToCgs: action.payload,
            }

        case actionTypes.CGS_TOTAL_CANDIDATES:
            return {
                ...state,
                cgs_totalCandidates: action.payload.cgs_totalCandidates,
            }

        case actionTypes.CGS_TOTAL_CENTRE:
            return {
                ...state,
                cgs_totalCentre: action.payload.cgs_totalCentre,
            }

        case actionTypes.GROUP_SESSION: {
            const newState = JSON.parse(JSON.stringify(state));
            newState.searchLoading = false;
            if (action.payload.transferFlowCheck.isTransferFlow) {
                newState.groupSessionResult.content = action.payload.groupSession.content.filter(v => {
                    return v.id !== action.payload.transferFlowCheck.cgsID
                });
                let totalCount = _.get(newState, 'groupSessionResult.content', [])
                newState.noResultFoundGroupSession = (totalCount.length === 0);
                newState.isLoading = false
            } else {
                newState.groupSessionResult = action.payload.groupSession;
                let totalCount = _.get(newState, 'groupSessionResult.content', [])
                newState.noResultFoundGroupSession = (totalCount.length === 0);
                newState.isLoading = false
            }
            return newState;
        }

        case actionTypes.FILTER_CGS_GROUP_SESSION: {
            const newState = JSON.parse(JSON.stringify(state));
            newState.groupSessionResult.content = state.groupSessionResult.content.filter(v => {
                return v.id !== action.payload
            });
            let totalCount = _.get(newState, 'groupSessionResult.content', [])
            newState.noResultFoundGroupSession = (totalCount.length === 0);
            return newState;
        }

        case actionTypes.GET_ALL_BUSINESS_STREAM:
            return {
                ...state,
                allBusinessStreams: action.payload,
            };

        case actionTypes.IS_COMPONENT_RE_UPDATE:
            return {
                ...state,
                isComponentReupdate: action.payload,
            };

        case actionTypes.IS_COMPONENT_RE_UPDATE_MCQ:
            return {
                ...state,
                isComponentReupdateMcq: action.payload,
            };
        case actionTypes.IS_SERIES_RE_UPDATE_MCQ:
            return {
                ...state,
                isSeriesRerendered: action.payload,
            };

        case actionTypes.IS_QUALIFICATION_RE_RENDERED_MCQ:
            return {
                ...state,
                isQualificationRerendered: action.payload,
            };
        case actionTypes.ASSESMENT_RE_UPDATES:
            return {
                ...state,
                isAssesmentReupdates: action.payload,
            };

        case actionTypes.RESET_GROUP_SESSION:
            return {
                ...state,
                noResultFoundGroupSession: false,
                isLoading: false,
                apiError: false,
                selectedCenterId: [],
                centerList: [],
                candidatesList: [],
                transferToCgs: {
                    id: ''
                }
            };

        case actionTypes.USERINFO:
            return {
                ...state,
                userInfo: action.payload,
                isLoading: false
            };
        case actionTypes.GET_SERIES_DROPDOWN_LIST:
            return {
                ...state,
                seriesList: action.payload,
                isLoadingSeriesList: false
            };

        case actionTypes.QUALIFICATION_DROPDOWN_LIST:
            return {
                ...state,
                qualificationList: action.payload,
            };

        case actionTypes.ASSESSMENT_QUALIFICATION:
            return {
                ...state,
                dmasAssesment: action.payload,
            };

        case actionTypes.GET_ASSESMENT_DROPDOWN_LIST:
            return {
                ...state,
                assesmentList: action.payload,
                updatedComponentList: [],
                isLoading: false
            };

        case actionTypes.GET_TIME_ZONE_DROPDOWN_LIST:
            return {
                ...state,
                timeZoneList: action.payload,
                isLoading: false
            };

        case actionTypes.CENTER_DATA_DETAILS:
            return {
                ...state,
                centerList: action.payload,
            };

        case actionTypes.CANDIDATE_DETAILS:
            return {
                ...state,
                candidatesList: action.payload,
            };


        case actionTypes.GET_COMPONENT_DROPDOWN_LIST: {
            if (!action.payload.isMandatory) {
                action.payload.list.unshift({
                    "componentName": "Select",
                    "componentId": ""
                })
            }
            return {
                ...state,
                componentList: action.payload.list,
                isLoading: false
            };
        }

        case actionTypes.MODAL_OPEN:
            return {
                ...state,
                modalOpen: action.payload,
            };

        case actionTypes.SEARCH_LIST_PAYLOAD:
            return {
                ...state,
                searchListPayload: action.payload,
            };

        case actionTypes.LOADING:
            return {
                ...state,
                isLoading: action.payload.isLoading,
            };
        case actionTypes.LOADING_REPLACE_TEST:
            return {
                ...state,
                isLoadingReplaceTest: action.payload.isLoading,
            };

        case actionTypes.LOADING_SERIES_LIST:
            return {
                ...state,
                isLoadingSeriesList: action.payload.isLoadingSeriesList,
            };

        case actionTypes.SET_API_ERROR:
            return {
                ...state,
                apiError: action.payload,
            };
        case actionTypes.TOTAL_CENTERS:
            return {
                ...state,
                totalCenters: action.payload,
            };

        case actionTypes.TOTAL_CANDIDATE_LIST:
            return {
                ...state,
                totalCandidate: action.payload,
            };

        case actionTypes.SUMMARY_UI_TABLE_LIST_CENTER:
            return {
                ...state,
                finalListOfCenter: action.payload,
            };

        case actionTypes.SUMMARY_UI_TABLE_LIST_CANDIDATE:
            return {
                ...state,
                finalListOfCandidates: action.payload,
            };



        default:
            return { ...state };
    }
};

export default dhsApplicationDataStore;
